import React, { useContext,  useState } from "react";
import "../../../assests/css/teachers/TeacherSetting.css";
import { FaUserCog, FaLock, FaBell } from "react-icons/fa";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import Swal from "sweetalert2";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";

const TeacherSetting = () => {
  const { baseUrl, loggedInTeacher } = useContext(AppContext);
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  ////////////////get the file////////////////
  // useEffect(() => {
  //   getTeacherProfile();
  // }, []);

  // const getTeacherProfile = () => {
  //   const formData = new FormData();

  // Filhal testing ke liye hardcoded id
  // formData.append("teacher_id", loggedInTeacher?.id);

  //   axios
  //     .post(`${baseUrl}/teacher/profile/profilesetting`, formData)
  //     .then((response) => {
  //       if (response.data.success) {
  //         setEmail(response.data.teacher.email);
  //         setPassword(response.data.teacher.password);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  const updatePassword = () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Passwords do not match",
      });
      return;
    }

    const formData = new FormData();
    formData.append("teacher_id", loggedInTeacher?.id);
    formData.append("password", newPassword);

    axios
      .post(`${baseUrl}/teacher/profile/updatePassword`, formData)
      .then((response) => {
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Password Updated Successfully",
          });

          setNewPassword("");
          setConfirmPassword("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ✅ Profile Update Alert
  const handleProfileUpdate = () => {
    Swal.fire({
      title: "Success!",
      text: "Profile Updated Successfully 🎉",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  return (
    <TeacherMasterLayout>
      {/* Topbar */}
      <header className="ta-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="ta-profile">👤</div>
      </header>

      <div className="tp-setting-container">
        <h2 className="tp-setting-title">⚙️ Teacher Settings</h2>

        {/* Profile Settings */}
        <div className="tp-setting-card">
          <h3 className="tp-setting-heading">
            <FaUserCog /> Profile Settings
          </h3>

          <div className="tp-setting-grid">
            <input
              type="email"
              placeholder="Email Address"
              value={loggedInTeacher?.email || ""}
              readOnly
            />
            <input type="password" value="********" readOnly />
          </div>

          <button className="tp-setting-btn" onClick={handleProfileUpdate}>
            Update Profile
          </button>
        </div>

        {/* Password Settings */}
        <div className="tp-setting-card">
          <h3 className="tp-setting-heading">
            <FaLock /> Change Password
          </h3>

          <div className="tp-setting-grid">
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button className="tp-setting-btn" onClick={updatePassword}>
            Change Password
          </button>
        </div>

        {/* Notification Settings */}
        <div className="tp-setting-card">
          <h3 className="tp-setting-heading">
            <FaBell /> Notifications
          </h3>

          <div className="tp-setting-toggle">
            <label>
              <input type="checkbox" /> Email Notifications
            </label>

            <label>
              <input type="checkbox" /> SMS Notifications
            </label>
          </div>
        </div>
      </div>
    </TeacherMasterLayout>
  );
};

export default TeacherSetting;
